export const subjectMovementOptions = [
    { value: 'STATIONARY', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.stationary' },
    { value: 'MOVE_FORWARD', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.moveForward' },
    {
        value: 'MOVE_BACKWARD',
        messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.moveBackward',
    },
    { value: 'MOVE_ASIDE', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.moveAside' },
    { value: 'ASCEND', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.ascend' },
    { value: 'DESCEND', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.descend' },
    { value: 'ROTATE', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.subjectMovement.rotate' },
];

export const cameraMovementOptions = [
    { value: 'STATIC', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.static' },
    { value: 'ZOOM_IN', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.zoomIn' },
    { value: 'ZOOM_OUT', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.zoomOut' },
    { value: 'PAN_LEFT_RIGHT', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.panLeftRight' },
    { value: 'TILT_UP', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.tiltUp' },
    { value: 'TILT_DOWN', messageId: 'creative.editor.tab.aiGenerated.imageToMotion.cameraMovement.tiltDown' },
];

export const MOTION_PARAM_CATEGORIES = {
    SUBJECT_MOVEMENT: 'subjectMovement',
    CAMERA_MOVEMENT: 'cameraMovement',
};

export const MOTION_PARAM_OPTIONS = {
    [MOTION_PARAM_CATEGORIES.SUBJECT_MOVEMENT]: subjectMovementOptions,
    [MOTION_PARAM_CATEGORIES.CAMERA_MOVEMENT]: cameraMovementOptions,
};
